import styled from 'styled-components';

const BrowseTilePairContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default BrowseTilePairContainer;
